module.exports = __webpack_public_path__ + "static/media/programmer-v2.4de86582.mp4";